<template>
  <router-link :to="{ name: 'PartDetails', query: queryProps}">
    {{ oemPartCode }}
  </router-link>
</template>

<script>
  export default {
    name: "PartDetailsLink",
    props: {
      oemPartCode: {
        type: String,
        default: null,
      },
      partId: {
        type: Number || String,
        default: null,
      },
      tab: {
        type: String,
        default: null,
      },
    },
    computed: {
      queryProps() {
        const props = {};

        if (this.oemPartCode) {
          props.oemPartCode = this.oemPartCode;
        }

        if (this.partId) {
          props.partId = this.partId;
        }

        if (this.tab) {
          props.tab = this.tab;
        }

        return props;
      },
    },
  };
</script>
